export default __webpack_public_path__ + "static/media/wheelchair.a64b0da0.svg";